export class AuthEntity{
    static _token: string|null;
    static setToken(token: string|null){
        AuthEntity._token = token;
    }
    static getToken(): string|null{
        return AuthEntity._token;
    }
}